// 아티스트 타입/포지션 관련 상수 & 헬퍼 (라벨/필터/아이콘을 한 곳에서 관리)

export const ARTIST_TYPE_LABELS = {
  band: "밴드",
  vocal: "보컬",
  rapper: "래퍼",
  guitar: "기타",
  keyboard: "키보드",
  drum: "드럼",
  bass: "베이스",
  dance: "댄스",
  composer: "작곡",
  mixing: "믹싱",
  voiceActor: "성우",
  performancePlanner: "공연기획",
  mc: "MC",
  filming: "촬영",
  lighting: "조명",
  sound: "음향",
  other: "그 외",

  // 레거시/호환
  mix: "그 외",
};

const KOREAN_TO_TYPE_KEY = {
  밴드: "band",
  보컬: "vocal",
  래퍼: "rapper",
  기타: "guitar",
  키보드: "keyboard",
  드럼: "drum",
  베이스: "bass",
  댄스: "dance",
  작곡: "composer",
  믹싱: "mixing",
  성우: "voiceActor",
  공연기획: "performancePlanner",
  MC: "mc",
  촬영: "filming",
  조명: "lighting",
  음향: "sound",
  "그 외": "other",
  믹스: "mix",
};

// 아이콘은 실제 파일명이 존재하는 키로만 매핑해야 함.
// (예: other.png 없음 → mix.png 사용)
const TYPE_TO_ICON_KEY = {
  rapper: "mix",
  composer: "mix",
  mixing: "mix",
  voiceActor: "vocal",
  performancePlanner: "mix",
  mc: "vocal",
  filming: "mix",
  lighting: "mix",
  sound: "mix",
  other: "mix",
  mix: "mix",
};

export function normalizeArtistTypeKey(typeKeyOrLabel) {
  if (!typeKeyOrLabel) return null;
  return KOREAN_TO_TYPE_KEY[typeKeyOrLabel] || typeKeyOrLabel;
}

export function getArtistTypeLabel(typeKeyOrLabel) {
  const key = normalizeArtistTypeKey(typeKeyOrLabel);
  if (!key) return "타입 미등록";
  return ARTIST_TYPE_LABELS[key] || typeKeyOrLabel || key || "타입 미등록";
}

export function getArtistTypeDisplayName(type) {
  if (!type) return "타입 미등록";

  if (Array.isArray(type)) {
    if (type.length === 0) return "타입 미등록";
    return type.map((t) => getArtistTypeLabel(t)).join(" / ");
  }

  return getArtistTypeLabel(type);
}

export function getArtistTypeIconKey(type) {
  if (!type) return "mix";

  const primary = Array.isArray(type) ? type[0] : type;
  const normalized = normalizeArtistTypeKey(primary);
  if (!normalized) return "mix";

  return TYPE_TO_ICON_KEY[normalized] || normalized;
}

// 개인 포지션(개인 아티스트에서만 선택)
export const ARTIST_POSITION_OPTIONS = [
  { value: "vocal", label: ARTIST_TYPE_LABELS.vocal },
  { value: "rapper", label: ARTIST_TYPE_LABELS.rapper },
  { value: "guitar", label: ARTIST_TYPE_LABELS.guitar },
  { value: "keyboard", label: ARTIST_TYPE_LABELS.keyboard },
  { value: "drum", label: ARTIST_TYPE_LABELS.drum },
  { value: "bass", label: ARTIST_TYPE_LABELS.bass },
  { value: "dance", label: ARTIST_TYPE_LABELS.dance },
  { value: "composer", label: ARTIST_TYPE_LABELS.composer },
  { value: "mixing", label: ARTIST_TYPE_LABELS.mixing },
  { value: "voiceActor", label: ARTIST_TYPE_LABELS.voiceActor },
  { value: "performancePlanner", label: ARTIST_TYPE_LABELS.performancePlanner },
  { value: "mc", label: ARTIST_TYPE_LABELS.mc },
  { value: "filming", label: ARTIST_TYPE_LABELS.filming },
  { value: "lighting", label: ARTIST_TYPE_LABELS.lighting },
  { value: "sound", label: ARTIST_TYPE_LABELS.sound },
  { value: "other", label: ARTIST_TYPE_LABELS.other },
];

// 관리자/드롭다운 등에서 쓰는 "밴드 포함" 타입 옵션
export const ARTIST_TYPE_OPTIONS_WITH_BAND = [
  { value: "vocal", label: ARTIST_TYPE_LABELS.vocal },
  { value: "band", label: ARTIST_TYPE_LABELS.band },
  { value: "guitar", label: ARTIST_TYPE_LABELS.guitar },
  { value: "keyboard", label: ARTIST_TYPE_LABELS.keyboard },
  { value: "drum", label: ARTIST_TYPE_LABELS.drum },
  { value: "bass", label: ARTIST_TYPE_LABELS.bass },
  { value: "dance", label: ARTIST_TYPE_LABELS.dance },
  { value: "voiceActor", label: ARTIST_TYPE_LABELS.voiceActor },
  { value: "performancePlanner", label: ARTIST_TYPE_LABELS.performancePlanner },
  { value: "mc", label: ARTIST_TYPE_LABELS.mc },
  { value: "filming", label: ARTIST_TYPE_LABELS.filming },
  { value: "lighting", label: ARTIST_TYPE_LABELS.lighting },
  { value: "sound", label: ARTIST_TYPE_LABELS.sound },
  { value: "other", label: ARTIST_TYPE_LABELS.other },
];

// 라이브 폼 - 함께한 사람들 역할 옵션
export const CREW_ROLE_OPTIONS = [
  "공연기획",
  "촬영",
  "스태프",
  "조명",
  "음향",
  "디자인",
  "굿즈제작",
  "주최",
  "운영"
];

// 비디오/작품 폼 - 함께한 사람들 역할 옵션 (믹싱, 편집, 일러스트, 작곡 등)
export const VIDEO_CREW_ROLE_OPTIONS = [
  "믹싱",
  "에디팅",
  "일러스트",
  "작곡",
  "작사",
  "편곡",
  "개사",
  "썸네일"
];

// 아티스트 목록(ArtistList) 상단 필터 버튼 옵션
export const ARTIST_LIST_FILTER_OPTIONS = [
  { key: "all", label: "전체" },
  { key: "band", label: ARTIST_TYPE_LABELS.band },
  { key: "vocal", label: ARTIST_TYPE_LABELS.vocal },
  { key: "guitar", label: ARTIST_TYPE_LABELS.guitar },
  { key: "keyboard", label: ARTIST_TYPE_LABELS.keyboard },
  { key: "drum", label: ARTIST_TYPE_LABELS.drum },
  { key: "bass", label: ARTIST_TYPE_LABELS.bass },
  { key: "dance", label: ARTIST_TYPE_LABELS.dance },
  { key: "voiceActor", label: ARTIST_TYPE_LABELS.voiceActor },
  { key: "performancePlanner", label: ARTIST_TYPE_LABELS.performancePlanner },
  { key: "mc", label: ARTIST_TYPE_LABELS.mc },
  { key: "filming", label: ARTIST_TYPE_LABELS.filming },
  { key: "lighting", label: ARTIST_TYPE_LABELS.lighting },
  { key: "sound", label: ARTIST_TYPE_LABELS.sound },
  { key: "other", label: ARTIST_TYPE_LABELS.other },
];

export function createArtistListSelectedTypes(defaultKey = "all") {
  const state = {};
  for (const opt of ARTIST_LIST_FILTER_OPTIONS) {
    state[opt.key] = false;
  }
  if (Object.prototype.hasOwnProperty.call(state, defaultKey)) {
    state[defaultKey] = true;
  } else {
    state.all = true;
  }
  return state;
}

export function getActiveArtistListTypeKey(selectedTypes) {
  if (!selectedTypes || selectedTypes.all) return "all";
  const key = Object.keys(selectedTypes).find(
    (k) => k !== "all" && selectedTypes[k]
  );
  return key || "all";
}

